import { supabase } from "../supabase/supabase";

interface IBackground {
    game?: string;
    hostIsInBackground?: boolean;
}

export class Background {
    game: string;
    hostIsInBackground: boolean;

    constructor(game: string, hostIsInBackground: boolean) {
        this.game = game;
        this.hostIsInBackground = hostIsInBackground;
    }

    static fromJson(json: IBackground) {
        return new Background(
            json.game ? json.game as string : "",
            json.hostIsInBackground ? json.hostIsInBackground as boolean : false,
        );
    }

    static async addNewBackground(gameId: string) {
        const { data, error } = await supabase
            .from("Backgrounds")
            .insert({
                game: gameId,
                hostIsInBackground: false,
            });
    }

    static async updateHostIsInBackground(gameId: string, newHostIsInBackground: boolean) {
        const { error } = await supabase
            .from("Backgrounds")
            .update({ hostIsInBackground: newHostIsInBackground })
            .eq("game", gameId);
    }
}